export default "__VITE_ASSET__1a09e658__"